import React, { lazy, LazyExoticComponent } from "react";

import { preloadVideos } from "@/hooks/usePreloadVideo";

export interface LazyComponentWithPreload<
    T extends React.ComponentType<any> = React.ComponentType<any>,
> extends LazyExoticComponent<T> {
    preload: (images?: string[], videos?: string[]) => void;
}

export const lazyWithPreload = <T extends React.ComponentType<any>>(
    factory: () => Promise<{ default: T }>
): LazyComponentWithPreload<T> => {
    const Component = lazy(factory) as LazyComponentWithPreload<T>;
    Component.preload = (images = [], videos = []) => {
        factory();

        images.forEach((src) => {
            const image = new Image();
            image.src = src;
        });

        if (videos.length > 0) {
            preloadVideos(videos);
        }
    };
    return Component;
};
